import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Lesson } from '../models';
import { LessonValue } from '../models';

export const lessonActions = createActionGroup({
    source: 'Lesson',
    events: {
        // Get
        'Get Lesson': props<{ id: string }>(),
        'Get Lesson Success': props<{ payload: Lesson }>(),
        'Get Lesson Error': props<{ code: number }>(),
        // Create
        'Create Lesson': props<{ value: LessonValue }>(),
        'Create Lesson Success': props<{ payload: Lesson }>(),
        'Create Lesson Error': props<{ code: number }>(),
        // Update
        'Update Lesson': props<{ id: string; value: LessonValue }>(),
        'Update Lesson Success': props<{ payload: Lesson }>(),
        'Update Lesson Error': props<{ code: number }>(),
        // Delete
        'Delete Lesson': props<{ id: string }>(),
        'Delete Lesson Success': props<{ id: string }>(),
        'Delete Lesson Error': props<{ code: number }>(),
        // Clear
        Clear: emptyProps(),
    },
});
